module.exports = __webpack_public_path__ + "img/smbc.b6d093ec.svg";